import React from 'react';
import { Space, Input, Select, Button, DatePicker } from 'antd';
import { Label } from '../Layouts';
import dayjs from 'dayjs'
import UserLookup from '../common/UserLookup';
import { TaskStatusOptions, TaskTypeOptions } from '../../constants';
import ProjectLookup from '../common/ProjectLookup';

const TaskFilter: React.FC<{ onSearch: () => void, values: Partial<SearchTaskParams>, onChange: (v: Partial<SearchTaskParams>) => void, slot?: React.ReactElement }> =
    ({ values: params, onChange: setParams, onSearch, slot }) => {
        return (
            <div style={{
                display: 'flex', flexWrap: 'wrap',
            }}>
                <div style={{ width: '100%', display: 'flex', marginBottom: 12 }}>
                    <Label style={{ width: 200 }}>
                        <Label>展会名称</Label>
                        <ProjectLookup
                            style={{ width: '100%' }}
                            allowClear
                            placeholder='请选择'
                            onChange={projectId => {
                                setParams({ ...params, projectId })
                            }} value={params.projectId} />
                    </Label>
                    <Label style={{ width: 200 }}>
                        <Label>工单状态</Label>
                        <Select
                            style={{ width: '100%' }}
                            allowClear
                            placeholder='请选择'
                            options={TaskStatusOptions}
                            onChange={taskStatus => {
                                setParams({ ...params, taskStatus })
                            }} value={params.taskStatus} />
                    </Label>
                    {/* <Label style={{ width: 200 }}>
                        <Label>工单类型</Label>
                        <Select
                            style={{ width: '100%' }}
                            allowClear
                            placeholder='请选择'
                            options={TaskTypeOptions}
                            onChange={taskType => {
                                setParams({ ...params, taskType })
                            }} value={params.taskType} />
                    </Label> */}
                    <Label style={{ width: 200 }}>
                        <Label>认领人</Label>
                        <UserLookup
                            style={{ width: '100%' }}
                            onChange={acceptorId => {
                                setParams({ ...params, acceptor: acceptorId })
                            }} value={params.acceptor} />
                    </Label>
                    <Label style={{ width: 400 }}>
                        <Label>认领时间</Label>
                        <DatePicker.RangePicker
                            showTime
                            needConfirm={false}
                            value={[
                                params.acceptStartDate ? dayjs(params.acceptStartDate) : null,
                                params.acceptEndDate ? dayjs(params.acceptEndDate) : null,
                            ]}
                            onChange={(_, [acceptStartDate, acceptEndDate]) => {
                                console.log(acceptStartDate, acceptEndDate)
                                setParams({
                                    ...params,
                                    acceptStartDate,
                                    acceptEndDate
                                })
                            }}
                            placeholder={['认领时间(起)', '认领时间(止)']} />
                    </Label>
                </div>
                <div style={{ width: '100%', display: 'flex' }}>

                    <Label style={{ width: 200 }}>
                        <Label>完成确认人</Label>
                        <UserLookup
                            style={{ width: '100%' }}
                            onChange={completerId => {
                                setParams({ ...params, completer: completerId })
                            }} value={params.completer} />
                    </Label>
                    <Label style={{ width: 400 }}>
                        <Label>完成确认时间</Label>
                        <DatePicker.RangePicker
                            needConfirm={false}
                            showTime
                            value={[
                                params.completeStartDate ? dayjs(params.completeStartDate) : null,
                                params.completeEndDate ? dayjs(params.completeEndDate) : null,
                            ]}
                            onChange={(_, [completeStartDate, completeEndDate]) => {
                                setParams({
                                    ...params,
                                    completeStartDate,
                                    completeEndDate
                                })
                            }}
                            placeholder={['完成时间(起)', '完成时间(止)']} />
                    </Label>
                    <Label style={{ width: 400 }}>
                        <Label>关闭时间</Label>
                        <DatePicker.RangePicker
                            needConfirm={false}
                            showTime
                            value={[
                                params.closeStartDate ? dayjs(params.closeStartDate) : null,
                                params.closeEndDate ? dayjs(params.closeEndDate) : null,
                            ]}
                            onChange={(_, [closeStartDate, closeEndDate]) => {
                                setParams({
                                    ...params,
                                    closeStartDate,
                                    closeEndDate
                                })
                            }}
                            placeholder={['关闭时间(起)', '关闭时间(止)']} />
                    </Label>
                    <Label style={{ width: 200 }}>
                        <Label>设备序列号</Label>
                        <Input
                            style={{ width: '100%' }}
                            allowClear
                            placeholder='请输入序列号'
                            onChange={(e) => {
                                setParams({ ...params, deviceSn: e.target.value || null })
                            }} value={params.deviceSn || undefined} />
                    </Label>
                </div>
                <div style={{ marginTop: '10px'}}>
                    <Button style={{ marginRight: '1em' }} onClick={onSearch} type='primary'>查询</Button>
                    {slot}
                </div>
            </div>
        );
    }

export default TaskFilter;